<!--  -->
<template>
  <div class="cold-temperature">
    <el-scrollbar style="height: 100%">
      <div class="storage flex-right">
        <!-- {{ storageList }} -->
        <div class="storage-item" v-for="item in storageList" :key="item.coldStorageCode">
          <div class="top">
            <div class="top-title">{{ item.coldStorageName }}</div>
            <div class="top-content">
              <span>容量：{{ item.capacity }}吨 </span>
              <span>面积：{{ item.area }}㎡ </span>
              <span>高度：{{ item.height }}m</span>
            </div>
          </div>
          <div class="storage-item_content flex-row">
            <table border="1" cellspacing="0" v-for="items in item.coldStorageNumberInfoList"
              :key="items.coldStorageNumberName">
              <tr>
                <th class="cold-bg cold-col">库号</th>
                <th class="cold-value">
                  {{ items.coldStorageNumberName }}
                </th>
              </tr>
              <tr v-for="els in items.deviceStatusList" :key="els.currentStatusName">
                <td class="cold-bg" :style="els.currentStatusName.indexOf('穿堂') > 0 ? 'background:rgb(255,192,0)' : ''">
                  {{ els.currentStatusName }}
                </td>
                <td class="cold-value" :style="els.currentStatusKey == 'temperature' && items.minTemperature && items.maxTemperature && (els.currentStatusValue < items.minTemperature || els.currentStatusValue > items.maxTemperature) ? 'color: red' : ''">
                  {{ els.currentStatusValue }}{{ els.unit }}
                </td>
              </tr>
            </table>
            <!-- <table border="1" cellspacing="0">
              <tr>
                <th class="cold-bg">库号</th>
                <th class="cold-value">
                  {{ item.coldStorageNumberInfoList[1].coldStorageNumberName }}
                </th>
              </tr>
              <tr v-for="(items, ind) in item.coldStorageNumberInfoList[0]
                .deviceStatusList" :key="items.currentStatusName">
                <td class="cold-bg" :style="items.currentStatusName.indexOf('穿堂') > 0 &&
                    item.coldStorageNumberInfoList[1].deviceStatusList[
                      ind
                    ].currentStatusName.indexOf('穿堂') > 0
                    ? 'background:rgb(255,192,0);'
                    : ''
                  ">
                  {{ items.currentStatusName }}
                </td>
                <td class="cold-value">
                  {{ items.currentStatusValue }}{{ items.unit }}
                </td>
              </tr>
            </table> -->
          </div>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { api } from "../api/api";

export default {
  data() {
    return {
      storageList: [],
      timer: null
    };
  },

  // components: {},

  // computed() { },

  mounted() {
    this.queryList();
    const self = this
    if (this.timer) {
      clearInterval(this.timer)
    }
    this.timer = setInterval(self.queryList, 5000)
  },

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },

  methods: {
    queryList() {
      this.$fetch(api.statDeviceByColdStorage, { deviceType: "25" }).then(
        (res) => {
          if (!res.success) {
            this.$message.error(res.msgContent);
          }
          this.storageList = res.returnObj;
          // console.log(this.storageList, ">>>>story");
        }
      );
    },
  },
};
</script>
<style>
.cold-temperature .el-scrollbar__view {
  height: 100%;
}
</style>
<style lang='scss' scoped>
// td {
//  border-collapse: collapse;
//  border: 1px solid;
//  padding: 0;
//  margin: 0;
// }
.top-title {
  font-weight: bold;
  font-size: 18px;
}

.cold-value {
  width: 80px;
  text-align: center;
}

.top-content {
  margin-top: 30px;
  margin-bottom: 10px;
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
}

.storage {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
}

.storage-item {
  // flex: 1;
  border-radius: 10px;
  border: 1px solid #909399;
  width: 32%;
  height: calc((100% - 100px) / 2);
  margin: 10px 5px;
  padding: 30px;
  background-color: #FFFFFF;
}

.storage-item_content {
  margin-top: 20px;
  flex-wrap: wrap;
  height: calc(100% - 100px);
  justify-content: space-between;
}

.border-b {
  border-bottom: 1px solid;
}

.cold-bg {
  background: rgba(0, 176, 240, 1);
}

.storage-item_value {
  border: 1px solid;
  width: 31%;
  margin: 10px 2px;
  // padding: 5px;
  height: 50%;
  background: rgba(0, 176, 240, 1);

  .row {
    flex: 1;
    font-size: 6px;
    align-items: center;
    padding: 5px 0;
    // margin: auto;
    // text-align: center;
  }
}
</style>